//
// Module for the Vendor Payment Adjustments Index view
//
rs.module("vendor/paymentadjustments/index",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, ajaxUrls) {

            // Hook up click event on the radio buttons to reload the grid data via ajax
            $.js(jsSelectors.filter).js(jsSelectors.statusRadioContainer).find("input").on('click', function () {

                $.js(jsSelectors.filter).js(jsSelectors.loadingSpinner).show();

                // Update grid
                gridModule.update(
                    ajaxUrls.getGridData,
                    { unpostedOnly: this.value },
                    lrsGridApi.agGridApi,
                    function done() {
                        $.js(jsSelectors.filter).js(jsSelectors.loadingSpinner).hide();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);